import '@lib/modernizr-lib';
export const Modernizr = (window as any).Modernizr;
